import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpune() {



    const cardData = {

keyword: "Mini Bus On Rent in Pune",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Mini Bus On Rent in Pune for group travel, corporate trips, weddings, school tours, pilgrimages, and outstation journeys. We provide well-maintained mini buses with seating options from 18 to 32 passengers, along with experienced drivers for safe and smooth travel. Our service includes doorstep pickup across Pune, flexible rental packages, 24/7 support, and transparent pricing, ensuring a convenient and hassle-free group travel experience.",

topPlaces: [
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular group travel destinations near Pune, known for lush green valleys, waterfalls, and scenic viewpoints. Mini bus rentals are ideal for corporate outings, school trips, and family tours to enjoy monsoon beauty and weekend getaways together."
    },
    {
        title: "Mahabaleshwar Hill Station",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, and cool climate. It is perfect for group travel in mini buses, offering a comfortable journey for families, schools, and corporate teams exploring nature and sightseeing together."
    },
    {
        title: "Shirdi Pilgrimage Tour",
        description:
            "Shirdi is one of the most visited pilgrimage destinations in Maharashtra dedicated to Sai Baba. Mini buses are widely used for group darshan trips, allowing families and devotees to travel together comfortably for spiritual visits."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is known for Trimbakeshwar Jyotirlinga, temples, and vineyards. It is a popular group travel destination for religious tours, school trips, and corporate outings using mini bus rentals from Pune."
    },
    {
        title: "Goa Beach Tour",
        description:
            "Goa is a long-distance group travel destination famous for beaches, nightlife, and adventure activities. Mini buses are ideal for friends, corporate groups, and wedding trips traveling from Pune for vacation tours."
    },
    {
        title: "Ashtavinayak Darshan Route",
        description:
            "The Ashtavinayak pilgrimage circuit includes eight sacred Ganpati temples across Maharashtra. Mini buses are commonly booked for group spiritual tours, offering comfort and convenience for family and religious travel."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred temple located in the Sahyadri hills surrounded by dense forest. It is a popular group pilgrimage destination where mini buses are used for comfortable family and devotee travel."
    },
    {
        title: "Alibaug Beaches",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches and forts. It is a popular group outing location for corporate trips, school tours, and family picnics using mini bus rentals from Pune."
    },
    {
        title: "Aurangabad Heritage Tour",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, both UNESCO World Heritage Sites. Mini buses are widely used for group heritage tours and educational trips from Pune."
    },
    {
        title: "Konkan Coastal Trip",
        description:
            "The Konkan coast including Diveagar, Harihareshwar, and Ganpatipule is a scenic group travel route. Mini buses provide comfortable long-distance travel for family vacations and beach tours from Pune."
    }
],



services: [
  {
    name: "Mini Bus on Rent",
    description: "Rising Cab Service offers Mini Bus on Rent for comfortable group travel, corporate transportation, family outings, weddings, school trips, and outstation tours. Our mini buses are well-maintained, spacious, fully air-conditioned, and driven by experienced chauffeurs. Whether you need transportation for a small group or a large gathering, we provide flexible rental packages, affordable pricing, and reliable service to ensure a smooth and comfortable journey."
  },
  {
    name: "Mini Bus Hire in Pune",
    description: "Book Mini Bus Hire in Pune with Rising Cab Service for local and outstation travel requirements. Our fleet includes multiple seating options suitable for corporate teams, family functions, pilgrimages, and tourist groups. We provide professional drivers, clean interiors, punctual service, and customized travel solutions for every occasion."
  },
  {
    name: "Minibus Hire with Driver for Outstation",
    description: "Our Minibus Hire with Driver for Outstation service offers safe and hassle-free travel to destinations across Maharashtra and India. Enjoy comfortable seating, experienced drivers familiar with long routes, and flexible travel schedules for family tours, corporate trips, and holiday vacations."
  },
  {
    name: "Mini Bus Rentals for Corporate Trip",
    description: "Rising Cab Service provides Mini Bus Rentals for Corporate Trip requirements including employee transportation, team outings, conferences, client visits, and business events. Our professional service ensures punctual pickups, comfortable travel, and reliable transportation management."
  },
  {
    name: "Small Bus Rental Service in Pune",
    description: "Small Bus Rental Service in Pune is ideal for group travel, educational tours, social events, and sightseeing trips. We offer modern mini buses equipped with comfortable seating, air conditioning, and experienced drivers to make every journey enjoyable and convenient."
  },
  {
    name: "Minibus Rental Near Me in Pune",
    description: "Looking for Minibus Rental Near Me in Pune? Rising Cab Service provides quick booking, doorstep pickup, and well-maintained mini buses for local and outstation travel. Our service is available across Pune with flexible rental options and affordable pricing."
  },
  {
    name: "Mini Bus Rent Per Km",
    description: "Get affordable Mini Bus Rent Per Km pricing with transparent fare structures and no hidden charges. We offer cost-effective rental solutions for corporate travel, family functions, weddings, tours, and long-distance journeys."
  },
  {
    name: "Mini Coach Hire in Pune",
    description: "Book Mini Coach Hire in Pune for premium group transportation with spacious interiors, comfortable seating, and professional chauffeur service. Perfect for corporate groups, wedding guests, sightseeing tours, and event transportation."
  },
  {
    name: "Mini Bus for Rent Near Me in Pune",
    description: "Mini Bus for Rent Near Me in Pune provides convenient transportation for groups of all sizes. We offer clean vehicles, experienced drivers, and flexible rental durations to meet your travel needs efficiently."
  },
  {
    name: "12 Seater Mini Bus on Rent Pune",
    description: "Hire a 12 Seater Mini Bus on Rent Pune for family trips, airport transfers, business travel, and weekend outings. Our vehicles provide comfortable seating, luggage space, and reliable service for short and long-distance journeys."
  },
  {
    name: "Mini Bus on Rent Near Me for Outstation",
    description: "Our Mini Bus on Rent Near Me for Outstation service offers safe and comfortable travel to popular destinations such as Lonavala, Mahabaleshwar, Shirdi, Goa, Nashik, and more. Enjoy smooth journeys with professional drivers and spacious vehicles."
  },
  {
    name: "Mini Bus for Lonavala Picnic from Pune",
    description: "Book Mini Bus for Lonavala Picnic from Pune and enjoy a fun-filled group outing with comfortable transportation. Perfect for families, friends, school groups, and corporate teams looking for a convenient travel solution."
  },
  {
    name: "Mini Bus Hire for Event in Pune",
    description: "Mini Bus Hire for Event in Pune is ideal for weddings, conferences, exhibitions, family functions, and social gatherings. We provide reliable transportation management with professional drivers and comfortable vehicles."
  },
  {
    name: "Pune to Goa Mini Bus",
    description: "Rising Cab Service offers Pune to Goa Mini Bus rentals for group vacations, corporate outings, and family holidays. Enjoy comfortable long-distance travel with AC vehicles, spacious seating, and experienced drivers."
  },
  {
    name: "Mini Bus Hire in Pimpri Chinchwad",
    description: "Mini Bus Hire in Pimpri Chinchwad provides convenient transportation solutions for local and outstation travel. We offer quick bookings, professional service, and multiple seating options to suit different group sizes."
  },
  {
    name: "Mini Bus Hire in Kharadi Pune",
    description: "Book Mini Bus Hire in Kharadi Pune for corporate travel, airport transfers, events, and group tours. Our well-maintained fleet and experienced drivers ensure a comfortable and reliable travel experience."
  },
  {
    name: "Minibus Hire for Wedding Party in Pune",
    description: "Minibus Hire for Wedding Party in Pune offers organized transportation for guests, family members, and wedding events. We ensure timely pickups, comfortable travel, and hassle-free transportation management."
  },
  {
    name: "Mini Bus On Rent in Hinjewadi",
    description: "Mini Bus On Rent in Hinjewadi is ideal for IT company transportation, corporate events, team outings, and group travel. We provide professional drivers, punctual service, and comfortable vehicles."
  },
  {
    name: "Mini Bus on Rent in Baner",
    description: "Book Mini Bus on Rent in Baner for local sightseeing, airport transfers, family functions, and outstation tours. Our service combines affordability, comfort, and reliability."
  },
  {
    name: "Mini Bus on Rent in Pune Near Me",
    description: "Mini Bus on Rent in Pune Near Me offers easy booking, flexible rental options, and professional transportation services across Pune. We cater to corporate, family, educational, and tourism travel requirements."
  },
  {
    name: "Luxury Mini Bus on Rent in Pune Near Me",
    description: "Experience premium group travel with Luxury Mini Bus on Rent in Pune Near Me. Our luxury fleet features spacious seating, modern interiors, air conditioning, and superior comfort for weddings, corporate events, and VIP transportation."
  },
  {
    name: "Mini Bus on Rent in Pune for Family",
    description: "Mini Bus on Rent in Pune for Family is perfect for family vacations, pilgrimages, reunions, and holiday trips. Enjoy spacious seating, safe travel, and customized itineraries with professional drivers."
  },
  {
    name: "13 Seater Mini Bus on Rent in Pune",
    description: "13 Seater Mini Bus on Rent in Pune is ideal for small groups seeking comfortable and affordable transportation for local and outstation travel."
  },
  {
    name: "15 Seater Mini Bus on Rent in Pune",
    description: "15 Seater Mini Bus on Rent in Pune offers comfortable group transportation for family trips, corporate outings, and event travel with experienced drivers."
  },
  {
    name: "17 Seater Mini Bus on Rent in Pune",
    description: "17 Seater Mini Bus on Rent in Pune provides spacious and economical travel solutions for medium-sized groups traveling locally or outstation."
  },
  {
    name: "20 Seater Mini Bus on Rent in Pune",
    description: "20 Seater Mini Bus on Rent in Pune is perfect for corporate groups, educational tours, wedding transportation, and sightseeing trips."
  },
  {
    name: "24 Seater Mini Bus on Rent in Pune",
    description: "24 Seater Mini Bus on Rent in Pune offers comfortable seating, luggage space, and reliable transportation for larger groups and organized tours."
  },
  {
    name: "27 Seater Mini Bus on Rent in Pune",
    description: "27 Seater Mini Bus on Rent in Pune is designed for large group travel, providing spacious interiors, comfortable seating, and safe transportation for long-distance journeys."
  }
],

tableData: [
  ["Mini Bus on Rent", "Mini Bus Hire in Pune"],
  ["Minibus Hire with Driver for Outstation", "Mini Bus Rentals for Corporate Trip"],
  ["Small Bus Rental Service in Pune", "Minibus Rental Near Me in Pune"],
  ["Mini Bus Rent Per Km", "Mini Coach Hire in Pune"],
  ["Mini Bus for Rent Near Me in Pune", "12 Seater Mini Bus on Rent Pune"],
  ["Mini Bus on Rent Near Me for Outstation", "Mini Bus for Lonavala Picnic from Pune"],
  ["Mini Bus Hire for Event in Pune", "Pune to Goa Mini Bus"],
  ["Mini Bus Hire in Pimpri Chinchwad", "Mini Bus Hire in Kharadi Pune"],
  ["Minibus Hire for Wedding Party in Pune", "Mini Bus On Rent in Hinjewadi"],
  ["Mini Bus on Rent in Baner", "Luxury Mini Bus on Rent in Pune Near Me"],
  ["Mini Bus on Rent in Pune for Family", "13 Seater Mini Bus on Rent in Pune"],
  ["15 Seater Mini Bus on Rent in Pune", "17 Seater Mini Bus on Rent in Pune"],
  ["20 Seater Mini Bus on Rent in Pune", "24 Seater Mini Bus on Rent in Pune"],
  ["27 Seater Mini Bus on Rent in Pune", "Mini Bus on Rent in Pune Near Me"]
],



whychoose: [
    {
        WhyChooseheading: "Affordable Mini Bus on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable mini bus rental services in Pune for family trips, corporate events, school outings, weddings, pilgrimages, and group tours."
    },
    {
        WhyChooseheading: "Multiple Seating Capacity Options",
        WhyChoosedescription: "Choose from 17 Seater, 20 Seater, 25 Seater, 32 Seater, and other mini bus options according to your group size and travel requirements."
    },
    {
        WhyChooseheading: "Perfect for Group Travel",
        WhyChoosedescription: "Our mini buses are ideal for family functions, company outings, educational tours, religious journeys, picnics, and sightseeing trips."
    },
    {
        WhyChooseheading: "AC and Non-AC Mini Bus Availability",
        WhyChoosedescription: "Customers can select both air-conditioned and non-air-conditioned mini buses depending on travel preferences and budget."
    },
    {
        WhyChooseheading: "Local and Outstation Mini Bus Service",
        WhyChoosedescription: "Mini buses are available for Pune city travel as well as outstation destinations including Mahabaleshwar, Lonavala, Shirdi, Nashik, Goa, Kolhapur, and Konkan tours."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Vehicle pickup and reporting services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Safe Group Travel",
        WhyChoosedescription: "Our professional drivers ensure safe driving, punctual service, and comfortable transportation for all passengers."
    },
    {
        WhyChooseheading: "Best Choice for Corporate and Family Events",
        WhyChoosedescription: "Rising Cab Service is trusted for employee transportation, wedding guest travel, family gatherings, school trips, and group tourism."
    }
]
};

const faqData = [
    {
        question: "What seating capacities are available in mini buses?",
        answer: "We provide 17 Seater, 20 Seater, 25 Seater, 32 Seater, and other mini bus options based on group size."
    },
    {
        question: "Can I rent a mini bus for outstation trips from Pune?",
        answer: "Yes, mini buses are available for outstation destinations across Maharashtra and other states."
    },
    {
        question: "Are AC mini buses available for hire?",
        answer: "Yes, both AC and Non-AC mini buses are available according to customer requirements."
    },
    {
        question: "Can mini buses be booked for corporate events?",
        answer: "Yes, mini buses are frequently used for employee transportation, conferences, corporate outings, and business events."
    },
    {
        question: "Do you provide mini buses for wedding functions?",
        answer: "Yes, mini buses can be arranged for wedding guest transportation, family events, and special occasions."
    },
    {
        question: "Can schools and colleges hire mini buses?",
        answer: "Yes, mini buses are available for educational tours, industrial visits, picnics, and student excursions."
    },
    {
        question: "Are drivers included with the mini bus rental?",
        answer: "Yes, all mini bus rentals include experienced and professional drivers."
    },
    {
        question: "Can I book a mini bus for pilgrimage tours?",
        answer: "Yes, mini buses are widely used for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, and other religious tours."
    },
    {
        question: "Is advance booking recommended for mini bus rentals?",
        answer: "Yes, advance reservations are recommended during weekends, holidays, wedding seasons, and festival periods."
    },
    {
        question: "How can I book a Mini Bus on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Mahesh Patil",
        feedback:
            "We hired a mini bus for our family trip to Mahabaleshwar. The vehicle was clean, spacious, and the journey was comfortable for everyone.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shweta Kulkarni",
        feedback:
            "Our company outing was managed perfectly with Rising Cab Service. The mini bus arrived on time, the driver was professional, and the travel experience was excellent.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mini Bus on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/mini-bus-rent-pune.jpg",
"description": "Book Mini Bus on Rent in Pune with Rising Cab Service for group travel, corporate trips, weddings, and outstation tours. Get comfortable AC mini buses with experienced drivers for safe and reliable travel.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹25/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/mini-bus-on-rent-pune"
}
};




    return (
        <div>


<Helmet>
  <title>Mini Bus on Rent in Pune | Group Travel & Corporate Trips | +91 9272511548</title>

<meta
 name="description"
 content="Book Mini Bus on Rent in Pune for group travel, corporate trips, weddings, and outstation journeys. Get safe and comfortable AC mini buses with professional drivers."
/>

<meta
 name="keywords"
 content="mini bus on rent, mini bus hire in pune, minibus hire with driver for outstation, mini bus rentals for corporate trip, small bus rental service in pune, minibus rental near me in pune, mini bus rent per km, mini coach hire in pune, mini bus for rent near me in pune, 12 seater mini bus on rent, mini bus booking pune, group travel bus pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Minibusonrentinpune;